import FormInputTypes from '../../../components/atoms/formEnums/formInputTypes';
import tableAdminOrganizations from './../../tableAdminOrganizations';

export default {
  title: 'Status',
  attributeName: 'liveGlobalSetupStatus',
  fields: [
    {
      attributeName: 'eventId',
      label: 'EventId',
      default:'(new)',
      required: true,
      disabled:true,
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Event ID',
      helpText: 'Event ID.',
      className:'col-sm-6'
    },
    {
      attributeName: 'eventName',
      label: 'Event name',
      default:'',
      required: true,
      disabled:true,
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Event name',
      helpText: 'Event name.',
      className:'col-sm-6'
    },
    {
      attributeName: 'status_live',
      type: FormInputTypes.STATUS,
      placeholder: 'Live status',
      secondaryValue: 'live_log',
      className:'col-sm-4',
      label: 'Live Status',
      tooltipPosition:'top',
      visibleWhen:{"field":"isTemplate","value":false},
      width: '10rem',
      canOrder: true,
      colors: {
        draft: 'bg-info',
        draft_template: 'bg-info',
        yaml_sent:'bg-warning',
        cloud_started:'bg-success',
        cloud_starting:'bg-warning',
        cloud_stopping:'bg-warning',
        cloud_stopped:'bg-warning',
        cloud_pending:'bg-warning',
        ingest_starting:'bg-warning',
        ingest_stopping:'bg-warning',
        ingest_stopped:'bg-warning',
        ingest_started:'bg-success',
        error:'bg-danger',
        open: 'bg-warning',
        close: 'bg-danger',
        not_ready: 'bg-danger',
        ready: 'bg-warning',
        publishing_video: 'bg-success',
        started:'bg-success',
        cloud_down:'bg-warning'
      },
    },
    {
      attributeName: 'status_cloud',
      label: 'Cloud status',
      helpText: 'Status of Cloud event.',
      type: FormInputTypes.STATUS,
      secondaryValue: 'cloud_log',
      className:'col-sm-4',
      tooltipPosition:'top',
      visibleWhen:{"field":"isTemplate","value":false},
      width: '10rem',
      colors: {
        not_connected: 'bg-gray',
        init_start: 'bg-warning',
        starting: 'bg-warning',
        shutting_down:'bg-warning',
        down:'bg-warning',
        stopping: 'bg-warning',
        stopped:'bg-warning',
        pending: 'bg-warning',
        started: 'bg-success',
        up:'bg-success',
        error: 'bg-danger',
        fatal: 'bg-danger',
      },
    },
    {
      attributeName: 'status_ingest',
      label: 'Ingest status',
      helpText: 'Status of Ingest event.',
      type: FormInputTypes.STATUS,
      secondaryValue: 'ingest_log',
      className:'col-sm-4',
      tooltipPosition:'top',
      visibleWhen:{"field":"isTemplate","value":false},
      width: '10rem',
      colors: {
        not_connected: 'bg-gray',
        starting:'bg-warning',
        stopping: 'bg-warning',
        pending:'bg-warning',
        started:'bg-success',
        stopped:'bg-warning',
        enqueued: 'bg-info',
        processing: 'bg-info',
        success: 'bg-success',
        error: 'bg-danger',
        fatal: 'bg-danger',
      },
    },
  ],
};
